<template>
  <div class="mains">
    <div class="campus">
      教材管理
      <span>></span>
      <router-link to="selfbook">自制教材区</router-link>
      <span>></span>
      <span @click="tiaozhuan_danyuan">编辑课本</span>
      <span>></span>
      编辑单元
    </div>
    <div class="xiaoqu">
      <el-card :span="24">
        <div class="xiaoqu_1">编辑单元</div>
        <div class="shenzhong">
          <i class="img_1"> <img src="@/assets/img/education-manage/campus/shenzhong.png" alt /> </i>
          自制课本分为"保存课本"与"发布课本"两种选择，保存课本是将自制的课本保存且存档，发布课本是将自制的课本发布至小程序端。
        </div>
        <div class="form_1 right kbfm">
          <el-form
            ref="forms"
            :model="form"
            :rules="FormRules"
            label-width="5.20833vw"
          >
            <el-form-item label="单元名称" prop="name">
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input
                v-model="form.name"
                placeholder="请输入课本名称 ( 可填写中英文，不超过15个字 )"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item
              label="板块框架"
              class="shangchuan_bg1"
              prop="orgcode"
            >
              <i>
                <img src="@/assets/img/education-manage/campus/bitian.png" alt />
              </i>
              <el-input
                v-model="orgcode"
                placeholder="请输入您新建的章节名称"
                @keyup.enter.native="addBookChapter"
              ></el-input>
              <div class="shangchuan_yinyue">
                <el-button class="daoru_btn" @click="addBookChapter">
                  新建 Chapter
                </el-button>
              </div>
            </el-form-item>

            <el-form-item label prop="orgcode" class="shangchuan_bg">
              <div class="grid-content">
                <div class="zsbg weijuchang">
                  <el-table :data="tableData" border style="width: 62.8125vw">
                    <el-table-column
                      prop="title"
                      label="单元及章节名称"
                      max-width="360"
                    >
                      <template slot-scope="scope1">
                        <!-- {{ scope1.row }} -->
                        <input
                          type="text"
                          class="yp_name"
                          :class="scope1.row.selected ? 'yp_name2' : 'yp_name1'"
                          v-model="scope1.row.title"
                          :disabled="scope1.row.selected"
                          :id="scope1.row.selected ? '' : 'inputId'"
                          @blur="blur1(scope1.$index, tableData)"
                          @keyup.13="blur1(scope1.$index, tableData)"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="章节排序">
                      <template slot-scope="scopes">
                        <el-input
                          v-model="scopes.row.seqnum"
                          class="yp_paixu"
                          @blur="blur1(scopes.$index, tableData)"
                          @keyup.enter.native="
                            $event.target.blur(scopes.$index, tableData)
                          "
                        ></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="stData">
                        <el-button
                          type="text"
                          @click="chong(stData.$index, tableData)"
                        >
                          重命名
                        </el-button>
                        <el-button
                          type="text"
                          @click="bianji_tiaozhuan(stData.row.id)"
                        >
                          编辑章节
                        </el-button>
                        <el-button
                          type="text"
                          @click="deleteBookChapter(stData.row.id)"
                        >
                          删除章节
                        </el-button>
                        <!-- <el-button type="text" @click="zhizuo_py(stData.row)">
                          添加课件
                        </el-button> -->
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>

export default {
  name: 'addBookChapter',
  data () {
    return {
      form: {
        name: ''
      },
      FormRules: {},
      orgcode: '',
      tableData: [],
      addbookId: '',
      UnitId: '',
      bj_zz: false
    }
  },
  created () {
    if (!this.$store.state.UnitId) {
      this.$router.push({ name: 'addBook' })
      return this.$message.error('您当前的Unit数据获取失败！')
    }

    this.UnitId = this.$store.state.UnitId
    if (this.$store.state.addbookIds) {
      this.addbookId = this.$store.state.addbookIds
    } else {
      this.addbookId = this.$store.state.addbookIdsss
    }
    // console.log(this.addbookId)

    this.getBookUnitById()
    this.getBookChapterListByUnitid()
  },
  destroyed () {
    localStorage.removeItem('UnitId')
    localStorage.removeItem('addbookIds')
    localStorage.removeItem('addbookIdsss')
  },
  watch: {
  },
  methods: {
    tiaozhuan_danyuan () {
      this.$store.commit('addbookId', this.addbookId)
      this.$router.push({ name: 'addBook' })
    },

    bianji_tiaozhuan (Chapter) {
      this.$store.commit('Chapter', Chapter)
      this.$store.commit('UnitIds', this.UnitId)
      this.$store.commit('addbookIdss', this.addbookId)
      this.$router.push({ name: 'addBookPageFromChapter' })
    },

    // 重命名
    chong (index, rows) {
      // console.log(index)
      // console.log(rows[index])
      rows[index].selected = false
      document.getElementById('inputId').focus()
      // this.$refs.id.focus()
    },

    blur1 (index, rows) {
      // console.log(rows[index])
      rows[index].selected = true

      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      // let orgid = window.sessionStorage.getItem('orgid')
      let pro = this.$http({
        url: '/edu/bookunit/updateBookChapter',
        method: 'POST',
        data: {
          unitid: this.UnitId,
          id: rows[index].id,
          title: rows[index].title,
          seqnum: rows[index].seqnum
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)
          if (result.data.code === 0) {
            this.getBookChapterListByUnitid()
            return this.$message.success('章节修改成功！')
          } else {
            return this.$message.error(result.data.message)
          }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('章节修改失败：' + err)
        })
    },

    // 查询章节列表
    getBookChapterListByUnitid () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/edu/bookunit/getBookChapterListByUnitid/' + this.UnitId,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro.then(result => {
        // console.log(result)
        if (result.data.code === 0) {
          this.tableData = result.data.data
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].selected = true
          }
        } else { return this.$message.error(result.data.message) }
      })
        .catch(err => {
          // console.log('error===============')
          this.$message.error('查询章节列表失败：' + err)
        })
    },

    // 新增章节
    addBookChapter () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      if (this.orgcode === '') {
        return this.$message.error('请输入章节的名称！')
      }
      let pro = this.$http({
        url: '/edu/bookunit/addBookChapter',
        method: 'POST',
        data: {
          unitid: this.UnitId,
          title: this.orgcode,
          seqnum: ''
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro.then(result => {
        // console.log(result)
        if (result.data.code === 0) {
          this.getBookChapterListByUnitid()
          this.orgcode = ''
        } else { return this.$message.error(result.data.message) }
      })
        .catch(err => {
          // console.log('error===============')
          this.$message.error('新增章节失败：' + err)
        })
    },

    // 删除章节
    deleteBookChapter (id) {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      this.$confirm('确认要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // axios请求服务器端实现删除
        let pro = this.$http({
          url: '/edu/bookunit/deleteBookChapter/' + id,
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token
          }
        })
        pro
          .then(result => {
            // console.log(result)
            if (result.data.code === 0) {
              this.getBookChapterListByUnitid()
              return this.$message.success('删除章节成功!')
            } else { return this.$message.error(result.data.message) }
          })
          .catch(err => {
            // console.log(err)
            return this.$message.error('删除章节失败：' + err)
          })
      })
    },

    // ID 查询Unit
    getBookUnitById () {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '')
      let pro = this.$http({
        url: '/edu/bookunit/getBookUnitById/' + this.UnitId,
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
      pro
        .then(result => {
          // console.log(result)

          if (result.data.code === 0) {
            this.form.name = result.data.data.title
          } else { return this.$message.error(result.data.message) }
        })
        .catch(err => {
          // console.log(err)
          return this.$message.error('查询Unit名称失败：' + err)
        })
    }
  }
}
</script>

<style lang="less">
</style>
